import React, { useCallback, ReactElement } from 'react';
import TextBlock from '../text-block/text-block.component';
import StructureService from '../../services/structure-service';
import FormatService from '../../services/format-service';
import useCurrentUserPermissions from '../../hooks/use-current-user-permissions';
import useStylesFilteredText from './filtered-text.styles';

const FilteredText: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isLimited,
    withMentions,
    withHashtags,
    text,
    mentionPermission,
    hashtagPermission,
  } = props;

  const { classes } = useStylesFilteredText();
  const permissionList: string[] = useCurrentUserPermissions();

  const filterText: Function = useCallback((sourceText: string, isLimited: boolean): string | null => {
    let resultText: string = isLimited
      ? `${sourceText.substring(0, FormatService.STRING_LIMIT_DEFAULT)}`
      + `${sourceText.length > FormatService.STRING_LIMIT_DEFAULT ? '...' : ''}`
      : sourceText;

    if (withMentions) {
      const isMentionLinkViewAllowed: boolean = mentionPermission
        ? StructureService.checkPermission(mentionPermission, permissionList) : true;

      resultText = !isMentionLinkViewAllowed && resultText
        ? FormatService.formatTextWithNoMentions(resultText) : resultText;
    }

    if (withHashtags) {
      const isHashtagLinkVIewAllowed: boolean = hashtagPermission
        ? StructureService.checkPermission(hashtagPermission, permissionList) : true;

      resultText = !isHashtagLinkVIewAllowed && resultText
        ? FormatService.formatTextWithNoHashtags(resultText) : resultText;
    }

    return FormatService.formatHtmlToComponent(resultText);
  }, [withMentions, permissionList]);

  return (
    <TextBlock className={classes.filteredText}>
      {filterText(text, isLimited || false)}
    </TextBlock>
  );
});

export default FilteredText;
